import React, { useState, useEffect } from "react";
import { Drawer, Row, Col, Spin } from "antd";
import WebhookLogListWidget from "./WebhookLogListWidget";
import WebhookLogDetail from "./WebhookLogDetail";
import { useTranslation } from "react-i18next";

export function DetailWebhookDrawer(props) {
  const { open, onClose, data } = props;
  const {t: translate} = useTranslation();
  const [loadingList, setLoadingList] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [logsData, setLogsData] = useState([]);
  const [selectedLog, setSelectedLog] = useState(null);

  useEffect(() => {
    if (open) {
      fetchLogList(data.id);
    }
  }, [open, data.id]);

  const fetchLogList = async (webhookId) => {
    setLoadingList(true);
    setTimeout(() => {
      const mockList = [
        {
          id: "7664393064772898523",
          status: "success",
          statusText: "Thành công",
          color: "success",
          duration: "2300ms (2,3 giây)",
          createdAt: "2026-07-20 07:01:12",
          webhookType: 1,
        },
        {
          id: "7664393064772898522",
          status: "failed",
          statusText: "Có lỗi xảy ra",
          color: "error",
          duration: "5200ms (5,2 giây)",
          createdAt: "2026-07-20 06:30:06",
          webhookType: 2,
        },
        {
          id: "7664393064772898521",
          status: "success",
          statusText: "Thành công",
          color: "success",
          duration: "450ms (0,45 giây)",
          createdAt: "2026-07-20 06:12:45",
          webhookType: 3,
        },
        {
          id: "7664393064772898520",
          status: "failed",
          statusText: "Có lỗi xảy ra",
          color: "error",
          duration: "30200ms (30,2 giây)",
          createdAt: "2026-07-20 05:50:18",
          webhookType: 100,
        },
        {
          id: "7664393064772898519",
          status: "success",
          statusText: "Thành công",
          color: "success",
          duration: "1200ms (1,2 giây)",
          createdAt: "2026-07-20 05:15:30",
          webhookType: 101,
        },
        {
          id: "7664393064772898518",
          status: "success",
          statusText: "Thành công",
          color: "success",
          duration: "890ms (0,89 giây)",
          createdAt: "2026-07-20 04:40:11",
          webhookType: 102,
        },
        {
          id: "7664393064772898517",
          status: "failed",
          statusText: "Có lỗi xảy ra",
          color: "error",
          duration: "30000ms (30 giây)",
          createdAt: "2026-07-20 04:05:59",
          webhookType: 103,
        },
        {
          id: "7664393064772898516",
          status: "success",
          statusText: "Thành công",
          color: "success",
          duration: "1500ms (1,5 giây)",
          createdAt: "2026-07-20 03:22:14",
          webhookType: 104,
        },
        {
          id: "7664393064772898514",
          status: "success",
          statusText: "Thành công",
          color: "success",
          duration: "670ms (0,67 giây)",
          createdAt: "2026-07-20 02:45:33",
          webhookType: 105,
        },
        {
          id: "7664393064772898513",
          status: "failed",
          statusText: "Có lỗi xảy ra",
          color: "error",
          duration: "30000ms (30 giây)",
          createdAt: "2026-07-20 02:10:02",
          webhookType: 106,
        },
        {
          id: "7664393064772898512",
          status: "success",
          statusText: "Thành công",
          color: "success",
          duration: "2100ms (2,1 giây)",
          createdAt: "2026-07-20 01:55:20",
          webhookType: 200,
        },
        {
          id: "7664393064772898511",
          status: "success",
          statusText: "Thành công",
          color: "success",
          duration: "1800ms (1,8 giây)",
          createdAt: "2026-07-20 01:20:09",
          webhookType: 300,
        },
        {
          id: "7664393064772898510",
          status: "failed",
          statusText: "Có lỗi xảy ra",
          color: "error",
          duration: "30000ms (30 giây)",
          createdAt: "2026-07-20 00:48:51",
          webhookType: 1,
        },
        {
          id: "7664393064772898509",
          status: "success",
          statusText: "Thành công",
          color: "success",
          duration: "950ms (0,95 giây)",
          createdAt: "2026-07-20 00:15:10",
          webhookType: 2,
        },
        {
          id: "7664393064772898508",
          status: "success",
          statusText: "Thành công",
          color: "success",
          duration: "1350ms (1,35 giây)",
          createdAt: "2026-07-19 23:50:44",
          webhookType: 3,
        },
        {
          id: "7664393064772898507",
          status: "failed",
          statusText: "Có lỗi xảy ra",
          color: "error",
          duration: "30000ms (30 giây)",
          createdAt: "2026-07-19 23:12:00",
          webhookType: 106,
        },
        {
          id: "7664393064772898506",
          status: "success",
          statusText: "Thành công",
          color: "success",
          duration: "1100ms (1,1 giây)",
          createdAt: "2026-07-19 22:45:19",
          webhookType: 105,
        },
        {
          id: "7664393064772898505",
          status: "success",
          statusText: "Thành công",
          color: "success",
          duration: "780ms (0,78 giây)",
          createdAt: "2026-07-19 22:01:05",
          webhookType: 104,
        },
      ];
      setLogsData(mockList);
      setLoadingList(false);
      if (mockList.length > 0) handleSelectLog(mockList[0]);
    }, 300);
  };

  const handleSelectLog = (logItem) => {
    setLoadingDetail(true);
    setTimeout(() => {
      setSelectedLog({
        ...logItem,
        request: {
          method: "POST",
          url: "https://api.telegram.org/bot.../sendMessage",
          headers: '{\n  "Content-Type": "application/json"\n}',
          body: '{\n  "chat_id": "-1003767917929"\n}',
        },
        response: '{\n  "ok": true\n}',
        error: logItem.status === "failed" ? `Timeout ${logItem.duration}` : null,
      });
      setLoadingDetail(false);
    }, 200);
  };

  return (
    <Drawer
      title={translate("webhook.detail")}
      placement="right"
      width="100vw"
      onClose={onClose}
      open={open}
      destroyOnClose
    >
      <Row gutter={[24, 24]} className="m-0 p-4">
        {/* Cột Trái: Tối thiểu 10/24 hoặc 12/24 để Filter không bị méo */}
        <Col xs={24} lg={10} xl={10} className="border-right pr-lg-3 pl-0">
          <Spin spinning={loadingList}>
            <WebhookLogListWidget
              logsData={logsData}
              selectedId={selectedLog?.id}
              onSelectLog={handleSelectLog}
              webhookName={data.webhookName}
              link={data.webhookUrl}
            />
          </Spin>
        </Col>

        {/* Cột Phải */}
        <Col xs={24} lg={14} xl={14} className="pl-lg-3 pr-0">
          <Spin spinning={loadingDetail}>
            <WebhookLogDetail logDetail={selectedLog} />
          </Spin>
        </Col>
      </Row>
    </Drawer>
  );
}
